import { Component, OnInit } from "@angular/core";
import { EmbryoService } from "../Services/Embryo.service";

@Component({
    selector: "app-cookie-popup",
    templateUrl: "./cookie-popup.component.html",
    styleUrls: ["./cookie-popup.component.scss"],
})
export class CookiePopupComponent implements OnInit {
	lang: any; 
    constructor(public embryoService: EmbryoService) {
        this.embryoService.emitLang.subscribe((lang: any) => {
            this.lang = lang;
        });
    }

    ngOnInit(): void {
        const cookie_consent = this.getCookie("user_cookie_consent");
        const cookieNotice = document.getElementById("cookieNotice") as HTMLElement;
        const hideCookie: boolean = JSON.parse(JSON.stringify(localStorage.getItem("hideCookie"))) as boolean;
        if (cookie_consent != "" || hideCookie) {
            cookieNotice.style.display = "none";
        }
        else {
            setTimeout(() => {
                cookieNotice.style.display = "block";
            }, 5000);
        }
    }
    // Create cookie
    setCookie(cname: any, cvalue: any, exdays: any) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    // Delete cookie
    deleteCookie(cname: any) {
        const d = new Date();
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=;" + expires + ";path=/";
    }

    // Read cookie
    getCookie(cname: any) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    // Set cookie consent
    acceptCookieConsent() {
        this.deleteCookie("user_cookie_consent");
        this.setCookie("user_cookie_consent", 1, 30);
        this.closeCookiePopup();
    }

    closeCookiePopup() {
        const cookieNotice = document.getElementById("cookieNotice") as HTMLElement;
        cookieNotice.style.display = "none";
        localStorage.setItem("hideCookie", "true");
    }
}
